import * as React from 'react';
import { Icon } from '../../Icon';
import { IIcon } from '../../../interfaces/IIcon';

export function RadioOnIcon({ width, height, viewBox, style, className }: IIcon) {
    const newViewProps = '0 0 20 20' ?? viewBox;
    const newColorProps = style.color ?? '#0099FF';
    return (
        <Icon
            width={width}
            height={height}
            viewBox={newViewProps}
            style={style}
            className={className}
        >
            <>
                <circle cx="10" cy="10" r="9.09091" stroke={newColorProps} strokeWidth="1.81818" />
                <circle cx="9.99996" cy="9.99999" r="5.45455" fill={newColorProps} />
            </>
        </Icon>
    );
}
